import React from 'react';
import {ProgressIndicator} from '@bosch/react-frok';
import {Container} from './UploadProgressIndicator.style'
import {generateIdentifier} from '../../utils/IdentityUtils';

export const uploadProgressIndicatorId = 'file-upload-progress-indicator';

/**
 * @name UploadProgressIndicator
 * @description
 * A centered progress indicator for showing a progress state
 */
export const UploadProgressIndicator: React.VFC = () => {
    return (
        <Container id={generateIdentifier()}>
            <ProgressIndicator id={generateIdentifier(uploadProgressIndicatorId)}
                               progress-id={generateIdentifier(uploadProgressIndicatorId)}
                               className={uploadProgressIndicatorId}
                               type='determinate'
                               progress={0}/>
        </Container>
    );
};
